import { SyntheticEvent } from 'react';

import { IMPLEMENTATION_FORM_EVENT_TYPES } from '../constants';

export const handleActionType = (event: SyntheticEvent) => {
  const eventType = ((event.nativeEvent as SubmitEvent).submitter as HTMLButtonElement).getAttribute(
    'data-event-type',
  );

  const shouldForward = eventType === IMPLEMENTATION_FORM_EVENT_TYPES.SAVE_AND_FORWARD;

  return {eventType, shouldForward};
}
